module.exports = __webpack_public_path__ + "static/foundingchild_kookaburra_square-d3e627ae6e931c907fe53a3d711878fe.jpg";